import {
  IonApp,
  IonNav,
  setupIonicReact
} from '@ionic/react';
import React, { useEffect, useRef, useState } from 'react'
import { spaTransitionAnimation } from './lib/transitionAnimation'

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';
import './theme/theme.scss';

//import { ApplicationContext } from './context'
//import { Picklist, PicklistRepository, User, UserRepository } from './services'
//import CollectPicklist from './pages/CollectPicklist'
import * as pages from './pages'
import * as services from './services'

setupIonicReact({
  mode: "md"
});

const users: services.CurrentUserService = new services.CurrentUserService()


const boot: () => Promise<{user: services.CurrentUser}> = async () => {
  return {
    user: await users.current()
  }
}
const bootPromise = boot()


const App: React.FC = () => {
  const navigationRef = useRef<HTMLIonNavElement>(null)
  const [user, setUser] = useState<services.CurrentUser>(null!)
  //const [picklists, setPicklists] = useState<Picklist[]>(null!)

  useEffect(() => {
    bootPromise.then((initialData) => {
      if (user == null) {
        setUser(initialData.user)
      }
    })
  }, [user])
  if (user === null) { return null }
  return (
    <IonApp>
        <IonNav
          animation={spaTransitionAnimation}
          ref={navigationRef}
          root={() => {
            return (<pages.Home nav={navigationRef.current!} user={user}/>)
        }}/>
    </IonApp>
  )
}

export default App;
